/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M8.638 9.87c.37.333.94.304 1.274-.065l1.825-2.23.03-.029a.4.4 0 0 1 .565.03l1.753 2.18a.904.904 0 0 0 1.275.07.898.898 0 0 0 .07-1.27L12.71 5.3a.904.904 0 0 0-1.342-.003L8.572 8.6a.898.898 0 0 0 .066 1.271Zm2.73 8.835a.904.904 0 0 0 1.342-.002l2.72-3.256a.898.898 0 0 0-.07-1.271.904.904 0 0 0-1.274.07l-1.754 2.18a.4.4 0 0 1-.595 0l-1.825-2.229a.904.904 0 0 0-1.274-.065.898.898 0 0 0-.066 1.27l2.796 3.303Z"
})), "0 0 24 24", "ShowMore");